import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, Menu, MenuItem, IconButton } from '@mui/material'

export async function copyToClipboard (text) {
  return navigator.clipboard.writeText(text)
}

const CopyToClipboard = ({ text, sx, menuOptions, disabled }) => {
  const [copied, setCopied] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)

  const handleCopy = async (copyText = text) => {
    try {
      await copyToClipboard(copyText)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  const handleMenuItemClick = (option) => {
    handleCopy(option.value)
    setAnchorEl(null)
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', ...sx }}>
      <IconButton
        onClick={menuOptions ? handleMenuClick : () => handleCopy()}
        size="small"
        sx={{ p: 0 }}
        aria-label="copy"
        disabled={disabled}
      >
        <ContentCopyIcon
          sx={{
            color: 'primary.main',
            fontSize: '1.5rem',
            cursor: 'pointer',
            '&:hover': {
              color: 'primary.dark',
            },
            opacity: disabled ? 0.5 : 1
          }}
        />
      </IconButton>
      {copied && (
        <span
          style={{
            marginLeft: '8px',
            color: 'green',
            position: 'absolute',
            top: '1.5rem',
            right: '-1rem',
          }}
        >
          Copied!
        </span>
      )}
      {menuOptions && (
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
        >
          {menuOptions.map((option) => (
            <MenuItem key={option.label} onClick={() => handleMenuItemClick(option)}>
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  )
}

CopyToClipboard.propTypes = {
  text: PropTypes.string.isRequired,
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
}

export default CopyToClipboard
